export default {
  "root": "_root_3srw2_1",
  "--reversed": "_--reversed_3srw2_1",
  "input": "_input_3srw2_1",
  "area": "_area_3srw2_1",
  "thumb": "_thumb_3srw2_1",
  "--size-small": "_--size-small_3srw2_1",
  "--size-medium": "_--size-medium_3srw2_1",
  "--size-large": "_--size-large_3srw2_1",
  "--size-small--m": "_--size-small--m_3srw2_1",
  "--size-medium--m": "_--size-medium--m_3srw2_1",
  "--size-large--m": "_--size-large--m_3srw2_1",
  "--size-small--l": "_--size-small--l_3srw2_1",
  "--size-medium--l": "_--size-medium--l_3srw2_1",
  "--size-large--l": "_--size-large--l_3srw2_1",
  "--size-small--xl": "_--size-small--xl_3srw2_1",
  "--size-medium--xl": "_--size-medium--xl_3srw2_1",
  "--size-large--xl": "_--size-large--xl_3srw2_1"
};import "ni:sha-256;lOyyK_eUfwDcpQY6ipZ0Gs8HDb6skcb98a2j-XBQCao";